// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";

let jsonCodec = Jzon.object3(param => [
  param.altitude,
  param.latitude,
  param.longitude
], param => ({
  TAG: "Ok",
  _0: {
    altitude: param[0],
    latitude: param[1],
    longitude: param[2]
  }
}), Jzon.field("altitude", Jzon.nullable(Jzon.float)), Jzon.field("latitude", Jzon.float), Jzon.field("longitude", Jzon.float));

function distance(param, param$1) {
  let lat2 = param$1.latitude;
  let lat1 = param.latitude;
  let toRadius = deg => deg * Math.PI / 180.0;
  let phi1 = toRadius(lat1);
  let phi2 = toRadius(lat2);
  let delta_phi = toRadius(lat2 - lat1);
  let delta_lambda = toRadius(param$1.longitude - param.longitude);
  let sin2 = x => {
    let s = Math.sin(x);
    return s * s;
  };
  let a = sin2(delta_phi / 2.0) + Math.cos(phi1) * Math.cos(phi2) * sin2(delta_lambda / 2.0);
  let c = 2.0 * Math.atan2(Math.sqrt(a), Math.sqrt(1.0 - a));
  return 6371.0 * c;
}

function toGoogleMapsURL(param) {
  return "https://www.google.com/maps/search/?" + new URLSearchParams([
    [
      "api",
      "1"
    ],
    [
      "query",
      param.latitude.toString() + `,` + param.longitude.toString()
    ]
  ]).toString();
}

export {
  jsonCodec,
  distance,
  toGoogleMapsURL,
}
/* jsonCodec Not a pure module */
